export const AUTHENTICATE = 'AUTHENTICATE';
 export const ERRORAUTHENTICATE = 'ERRORAUTHENTICATE';
 export const RESETAUTHENTICATE = 'RESETAUTHENTICATE';
export const DEAUTHENTICATE = 'DEAUTHENTICATE';
export const REGISTER = 'REGISTER';
export const USERISLOGOUT = 'USERISLOGOUT';
